import { Box, LinearProgress, Tooltip, Typography, useTheme } from "@mui/material";
import * as React from "react";
import { Base } from "../../../framework/base";

export interface IProgressBarProp {
  customColor?: string;
  customBackColor?: string;
  animated?: boolean;
  minValue?: number;
  maxValue?: number;
  margin?: string;
  striped?: boolean;
  color?:
    | "info"
    | "success"
    | "warning"
    | "error"
    | "primary"
    | "secondary"
    | "inherit";
  text?: string;
  tooltip?: string;
  value: number;
  valueInEnd?: boolean;
}

export const ProgressBar = ({
    value,
    color = "info",
    customColor,
    customBackColor,
    maxValue = 100,
    minValue = 0,
    text,
    tooltip,
    margin,
    valueInEnd,
}: IProgressBarProp) => {
    const theme = useTheme();
    const val = Math.max(
        Math.min(!Base.isNullOrUndefined(value) ? value : 0, maxValue),
        minValue
    );
    const range = maxValue - minValue;
    const percent = range > 0 ? (val / range) * 100 : 0;
    const textColor = !customBackColor
        ? theme.palette.getContrastText(
            percent < 15 ? theme.palette[color].light : theme.palette[color].main
        )
        : Base.invertColor(customBackColor, true);

    const bar = <Box sx={{ width: "100%", position: "relative", margin: valueInEnd ? undefined : margin }} title={tooltip ?? text}>
        <LinearProgress
            variant="determinate"
            value={percent}
            color={customColor ? undefined : color}
            sx={{
                "height": "19px",
                "borderRadius": "9px",
                "backgroundColor": !customBackColor ? undefined : customBackColor,
                "& .MuiLinearProgress-bar": {
                    backgroundColor: !customColor ? undefined : customColor,
                },
            }}
            aria-valuenow={value}
            aria-valuemin={minValue}
            aria-valuemax={maxValue}
        />
        <Typography
            variant="caption"
            sx={{
                position: "absolute",
                left: ".5rem",
                top: 0,
                color: textColor,
            }}
        >
            {text}
        </Typography>
    </Box>;

    if (!valueInEnd) return bar;

    return (
        <Box sx={{ width: "100%", position: "relative", margin, display: "flex", alignItems: "center" }} title={tooltip ?? text}>
            {bar}
            {valueInEnd &&
                <Tooltip title={value.toString()}>
                    <Typography
                        variant="caption"
                        component="div"
                        sx={{
                            marginLeft: ".5rem",
                            width: "35px",
                            overflow: "hidden",
                            fontWeight: "bold",
                            textAlign: "right",
                        }}
                    >
                        {value}
                    </Typography>
                </Tooltip>
            }
        </Box>
    );
};
